import { Button, FormControl, List, ListItem, Popover, TextField, Tooltip } from "@mui/material";
import asset from "json/assets";
import TeeTypeSelect from "components/DraggableList/TeeTypeSelect";
import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import styles from "styles/component/DraggableList.module.scss";


function DraggableList({courseTeeDetails,teeColorList,teeTypeOptions, draggableTeeArray
  ,addedNewcourseTeeList, onCreateTeeType
  // onSelectColor,
}) {
  const modifiedCourseTeeDetails = courseTeeDetails?.map(item => ({
     ...item,
     displayOrder: item?.displayOrder.toString()
  }));
  const [teeBoxList, updateTeeboxList] = useState(modifiedCourseTeeDetails);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedTeeId, setSelectedTeeId]=useState();


  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event, index) => {

    const buttons = document.getElementsByClassName(styles.button);
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].classList.remove('active');
    }
    event.currentTarget.classList.add('active');

    setAnchorEl(event.currentTarget);
    setSelectedTeeId(index)
  
  };
  

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    draggableTeeArray(teeBoxList)
  }, [teeBoxList])

  useEffect(() => {
    updateTeeboxList(modifiedCourseTeeDetails)
  }, [courseTeeDetails])
  
  useEffect(() => {
    updateTeeboxList(addedNewcourseTeeList)
  }, [addedNewcourseTeeList])

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(teeBoxList);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

   const modifiedTeeitems = items?.map(item => ({
        ...item,
     displayOrder: (item?.displayOrder).toString()
   }));
    // updateTeeboxList(items);
    updateTeeboxList(modifiedTeeitems);
  }

  const handleSelectTeeType = (teeType, id) => {
    const updatedData = teeBoxList?.map((character, i) => {
      if (i === id) {
        return { ...character, teeName: teeType?.name, id_courseTeeType: Number(teeType?.id_courseTeeType) };
      }
      return character;
    });
    updateTeeboxList(updatedData);
  };


const handleInputChange = (index, key, value)=>{

  const updatedListData = teeBoxList?.map((item, i) =>
  i === index ? { ...item, [key]: value } : item
);
updateTeeboxList(updatedListData);
}

const removeItem = (indexToRemove) => {
  const deletedList = teeBoxList?.filter((_, index) => index !== indexToRemove);
  updateTeeboxList(deletedList);
};

const handleSelectColor = (e,teeColor,index) =>{
    // onSelectColor(teeColor?.hexColor)
   const updated = teeBoxList?.map((character, i) => {
         if (i === selectedTeeId ) {
  
            return { ...character, teeColorName: teeColor?.name, 
                teeColorValue: teeColor?.hexColor, id_courseTeeColor: teeColor?.id_courseTeeColor};
         }
           return character;
   });

   updateTeeboxList(updated);
  handleClose();
}

const handleClickGender = (value,index)=>{
 const updated = teeBoxList?.map((character, i) => {
  if (i === index ) {
     return { ...character, gender: value};
  }
    return character;
});
updateTeeboxList(updated);

}
  return (
    <div className={styles.drag_section}>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="characters">
          {(provided) => (
            <>
              <ul className={styles.list_hdr}>
                <li>POS:</li>
                <li>TEE NAME:</li>
                <li>COL:</li>
                <li>GEN:</li>
                <li>RAT-M:</li>
                <li>RAT-W:</li>
                <li>SLO-M:</li>
                <li>SLO-W:</li>
                <li></li>
              </ul>
              <ul
                {...provided.droppableProps}
                ref={provided.innerRef}
                className={styles.list_body}
              >
                 {teeBoxList?.length !== 0 ? 
                  
                       (teeBoxList?.map((item, index) => {
                  return (
                    <Draggable
                      key={item.displayOrder}
                      draggableId={item.displayOrder}
                      index={index}
                    >
                      {(provided) => (
                        <li
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          tabIndex="-1"
                        >
                          <div className={styles.cmn_lists} tabIndex="-1">
                            <div className={styles.innr_list}>
                              <img
                                src={asset.menuicon2}
                                alt=""
                                width={22}
                             
                              />
                              <p>{index + 1}</p>
                            </div>
                          </div>
                          <div className={`${styles.formGroup} ${styles.cmn_lists}`}>
                          <FormControl key={item.id} >
                            <TeeTypeSelect
                              options={teeTypeOptions}
                              selectedId={item?.id_courseTeeType}
                              onSelect={(teeType) => handleSelectTeeType(teeType, index)}
                              onCreate={onCreateTeeType}
                            />
                          </FormControl>
                          </div>
                          <div className={`${styles.cmn_btns} ${styles.cmn_lists} `}>
                            <button type="button" tabIndex="-1"
                             onClick={(event) => handleClick(event,index)}
                              className={`${styles.button} cmn_btn `  }
                              style={{
                                backgroundColor: `#${item.teeColorValue}`,

                              }}
                            ></button>
                          </div>
                          <div className={`${styles.cmn_btns} ${styles.cmn_lists} `}>
                            <Tooltip title={<div>
                              <button type="button" onClick={() => handleClickGender('men',index)}>M</button>
                              <button type="button" onClick={() => handleClickGender('wmn',index)}>W</button>
                            </div>} PopperProps={{
                              className:"genderSelect_class"
                            }}  arrow  placement="top">
                            <button tabIndex="-1" type="button"
                              className={`${styles.button} ${styles.default}`}
                            >
                              {" "}
                              {item.gender.substring(0, 1).toUpperCase()}{" "}
                            </button>
                            </Tooltip>
                          </div>
                          <div className={`${styles.form_grp} ${styles.cmn_lists} `}>
                            <TextField
                              inputProps={{
                                maxLength: 5,
                                // pattern: "[0-9]*",
                              }}
                              type="text"
                              defaultValue={item?.ratingMen}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "ratingMen",
                                  parseFloat(e.target.value)
                                )
                              }
                              onInput={(e) => { 
                                // e.target.value
                                
                                // e.target.value = Math.max(
                                //   0,
                                //   parseFloat(e.target.value)
                                // )
                                //   .toString()
                                //   .slice(0, 3);
                              }}
                              min={0}
                            />
                          </div>
                          <div className={`${styles.form_grp} ${styles.cmn_lists} `}>
                            <TextField
                              inputProps={{
                                maxLength: 3,
                                 step: "0.1"
                                // pattern: "[0-9]*",
                              }}
                              type="number"
                              defaultValue={item?.ratingWomen}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "ratingWomen",
                                  parseFloat(e.target.value)
                                )
                              }
                              onInput={(e) => {
                                // e.target.value
                                // e.target.value = Math.max(
                                //   0,
                                //   parseInt(e.target.value)
                                // )
                                //   .toString()
                                //   .slice(0, 3);
                              }}
                              min={0}
                            />
                          </div>
                          <div className={`${styles.form_grp} ${styles.cmn_lists} `}>
                            <TextField
                              inputProps={{
                                maxLength: 3,
                                // pattern: "[0-9]*",
                              }}
                              type="number"
                              defaultValue={item?.slopeMen}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "slopeMen",
                                  parseFloat(e.target.value)
                                )
                              }
                              onInput={(e) => {
                                // e.target.value 
                                // = Math.max(
                                //   0,
                                //   parseInt(e.target.value)
                                // )
                                //   .toString()
                                //   .slice(0, 3);
                              }}
                              min={0}
                            />
                          </div>
                          <div className={`${styles.form_grp} ${styles.cmn_lists} `}>
                            <TextField
                              inputProps={{
                                maxLength: 3,
                                // pattern: "[0-9]*",
                              }}
                              type="number"
                              defaultValue={item?.slopeWomen}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "slopeWomen",
                                  parseFloat(e.target.value)
                                )
                              }
                              onInput={(e) => {
                                // e.target.value 
                                // = Math.max(
                                //   0,
                                //   parseInt(e.target.value)
                                // )
                                //   .toString()
                                //   .slice(0, 3);
                              }}
                              min={0}
                            />
                          </div>
                          <div className={styles.cmn_lists}>
                            <button type="button"  onClick={() => removeItem(index)} className={styles.close_icon} tabIndex="-1">
                              <img src={asset.close} alt="" />
                            </button>
                          </div>
                        </li>
                      )}
                    </Draggable>
                  );
                }))
                      : ( <div className={styles.notFound}>
                        <p className={styles.notFoundData}>No Tee Data Available</p>
                      </div>)}
                {provided.placeholder}
              </ul>
            </>
          )}
        </Droppable>
      </DragDropContext>
      <Popover
  id="{id}"
  className="custom_picker"
  open={open}
  anchorEl={anchorEl}
  onClose={handleClose}
  anchorOrigin={{
    vertical: 'top',
    horizontal: 'center',
  }}
  transformOrigin={{
    vertical: 'bottom',
    horizontal: 'center',
  }}
>

<List disablePadding >
   
   {teeColorList?.courseTeeColorList?.map((item, index) =>
   <ListItem disablePadding key={item.id_courseTeeColor}>
  <Tooltip title={item.name} arrow placement="top" PopperProps={{ className: "teeColorTooltip_class" }}>
  <Button style={{backgroundColor: `#${item.hexColor}`}}
       onClick={(e)=>handleSelectColor(e,item,index)}></Button>
  </Tooltip>
  </ListItem>
)}
   

 </List>

 

</Popover>
    </div>
  );
}

export default DraggableList;
